import styled from 'styled-components';
import { IMAGE_SHAPE } from '@common/Utility/constants';

export const SixInOneStyled = styled.div`
  .ePharmacy {
    .link {
      color: ${(props) => props?.theme?.green?.dark};
      &:hover {
        color: ${(props) => props?.theme?.green?.light};
      }
    }
  }
  .container {
    padding: ${(props) => !props?.title && !props?.viewAll ? '16px 0' : !props?.title && props?.viewAll ? '16px 0 0 0' : '4px'};
  }
  .homeCare {
    .link {
      color: ${(props) => props?.theme.blue.royal};

      &:hover {
        color: ${(props) => props?.theme?.royalBlue?.dark};
      }
    }
    .categoryItemBox {
      &.newDesign {
        .item {
          .img {
            border: 1px solid ${(props) => props?.theme?.royalBlue?.lightGrey};
          }
        }
      }
    }
  }
  .slick-slider {
    margin-bottom: 20px;
    .slick-list {
      width: 100%;
      margin: 0;
    }
  }
  .categoryItemBox {
    width: 100%;
    cursor: pointer;
    color: inherit;
    text-decoration: inherit;
    display: flex;
    .item {
      width: 100%;
      margin: 0 7px 0 8px;
      padding: 23px 16px 24px 16px;
      background: ${(props) => props?.theme?.color?.white};
      border: 1px solid ${(props) => props?.theme?.grey?.iconBg};
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .img {
      width: 108px;
      height: 108px;
      margin: 0 0 8px 0;
      border-radius: ${(props) => props?.imageShape === IMAGE_SHAPE?.RECTANGLE ? '0px' : '50%'};
      display: flex;
      justify-content: center;
      align-items: center;
      > div {
        position: relative !important;
        > img {
          width: 100% !important;
          height: 100% !important;
          max-width: 133px !important;
          max-height: 103px !important;
          /* position: relative !important;
          min-width: 80px !important; */
        }
      }
    }
    .name {
      width: 90%;
      height: 42px;
      font-size: 15px;
      line-height: 21px;
      font-weight: 600;
      text-align: center;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }
    &.newDesign {
      .item {
        background: transparent;
        border: 0;
        padding: 0;
        .img {
          border: ${(props) => props?.imageShape === IMAGE_SHAPE?.RECTANGLE ? '0px' : `1px solid ${props?.theme?.grey?.iconBg}`};
          margin-bottom: 16px;
          height: 110px;
          width: 110px;
          > div {
            border-radius: ${(props) => props?.imageShape === IMAGE_SHAPE?.RECTANGLE ? '8px' : '50%'};
          }
        }
      }
    }
  }

  .sectionBox {
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  @media (max-width: 820px) {
    padding: 0 0 5px 0;
    .container {
      padding: 16px 0;
    }
    .slick-slider {
      margin: 0;
      .slick-slide {
        width: 17.5vw !important;
      }
    }
  }
  @media (max-width: 767px) {
    .flex-ItemBox-wrap{
      flex-wrap: wrap;
      gap: 2em;
    }
    .categoryItemBox {
       &.newDesign {
         .item {
          .img {
            height: 115px;
            width: 115px;
          }
        }
         &.large{
           width: 29.3%;
         }
       }
    }
  }
@media (max-width: 572px) {
   .flex-ItemBox-wrap{
      gap: 20px;
    }
    .categoryItemBox {
          &.newDesign {
            .item {
              .img {
                height: 110px;
                width: 110px;
              }
            }
          }
       }
    }
  @media (max-width: 480px) {
    padding-bottom: 0;
    .flex-ItemBox-wrap{
      gap: 0px;
    }
    .slick-slider {
      .slick-slide {
        width: 30vw !important;
      }
    }
    .sectionBox {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      .slick-track {
        margin-left: 32px;
      }
      .container {
        padding-bottom: 0;
        .titleBar {
          padding-left: 16px;
          padding-right: 16px;
        }
        .slick-arrow {
          &.slick-prev {
            left: 0;
          }
          &.slick-next {
            right: 0;
          }
        }
      }
    }
    .categoryItemBox {
      width: calc(100% - 12px);
      margin: 0 6px 10px 6px;
      box-sizing: border-box;
      .item {
        width: 100%;
        margin: 0;
        box-sizing: border-box;
      }
      .name {
        margin-bottom: 16px;
      }
    }
  }
`;